import React from 'react';
import L from "leaflet";
import cartoclient from '../services/cartoclient';
import { tileWithLabel, attribution, minZoom} from '../services/map';
import Layer from './Layer';
import { connect } from 'react-redux';
import { Map, TileLayer, ZoomControl } from 'react-leaflet';
import { startSetGeoName } from '../actions/globalState';

export class MapMain extends React.Component {
  state = {
    nativeMap: undefined
    }

  componentDidMount() {
    this.setState({ nativeMap: this.nativeMap });
  }
  onClick = (geo_name) => {
    //console.log('on click in parent map', geo_name)
    if (geo_name !== 'Brisbane (C)') {
      this.props.startSetGeoName(geo_name);
    }
  }

  render() {
    const { nativeMap } = this.state;
    //console.log('mapLayers', this.props.mapLayers, 'nativeMap', this.nativeMap);
    if (this.props.mapLayers === undefined || this.props.mapLayers.layers === undefined) {
      return (<div></div>)
    }
    return (

      <Map minZoom={minZoom} zoom={this.props.mapLayers.map.zoom} 
      bounds={this.props.mapLayers.boundArray}  zoomControl={false}
        ref={node => { 
          this.nativeMap = node && node.leafletElement 
          //console.log('node', node)
        }}>
        <ZoomControl position="bottomright" />
        <TileLayer attribution="" url={this.props.mapLayers.mapType} />
          {this.nativeMap && 
            <Layer onClick={(geo_name) => this.onClick(geo_name)} 
              map={this.nativeMap}        
              sql={this.props.mapLayers.layers.sql}
              cartocss={this.props.mapLayers.layers.cartocss}
              client={cartoclient}
              visible={this.props.mapLayers.layers.visible} 
              options={this.props.mapLayers.layers.options} 
              total={this.props.mapLayers.mapTotal} 
              table={this.props.mapLayers.data_table.display_name}/>
          }
        <TileLayer url={tileWithLabel} />        
      </Map>
    )
  }
}

const mapStateToProps = (state, props) => {
  return {
    mapLayers: state.globalState
  };
};

const mapDispatchToProps = (dispatch) => ({
  startSetGeoName: (geo_name) => dispatch(startSetGeoName(geo_name))
});

export default connect(mapStateToProps, mapDispatchToProps)(MapMain);






// WEBPACK FOOTER //
// ./src/components/MapMain.js